import styled from 'styled-components'
import { CloseIconArrow } from 'icons/CloseIconArrow'
import { SideBarDeleteIcon } from 'icons/SideBarDeleteIcon'
import { SideBarEditIcon } from 'icons/SideBarEditIcon'
import { Typography } from '@mui/material'
import { SideBarThreeCircle } from 'icons/SideBarThreeCircle'
import { DesktopImg } from 'pages/Profile/style'

interface IPropsSideBar {
    isOpen: boolean,
}
interface IsOwnerSideBar {
    isOwner: boolean,
}
interface isOpenEditSideBar {
    isOpenEdit: boolean,
}
export const NewSideBar = styled.div<IPropsSideBar & isOpenEditSideBar>`
@media(max-width: 844px){
    border-radius: 20px;
    height: ${props => (props.isOpenEdit ? 'auto' : (props.isOpen && '135px'))};
    width: 100%;
    position: fixed; 
    z-index: 10; 
    bottom: 0%;
    transition: 0.5s;
    background-color: #FFFFFF;
}
@media(min-width: 844px){
    border-radius: 20px;
    height: 580px;
    width: ${props => (props.isOpen ? '400px' : '0')}; 
    position: fixed; 
    z-index: 10; 
    top: 16%;
    left: ${props => (props.isOpen ? '2%' : '0%')};
    background-color: #FFFFFF;
    transition: 0.5s;
    box-shadow:0px 15px 25px -11px rgba(34, 60, 80, 0.2);
}
`
export const RelativeCardDiv = styled.div<IPropsSideBar>`
@media(max-width: 844px){
    display:${props => (props.isOpen ? 'flex' : 'none')};
    flex-direction:column;
    align-items:flex-start;
    box-shadow: 0px 100px 95px -74px rgba(20, 156, 132, 0.5) inset,0px 15px 25px -11px rgba(34, 60, 80, 0.2);  
    background-color: #FFFFFF;
    white-space: nowrap; 
    width: 100%; 
    border-radius:20px;
    z-index:2;
}
@media(min-width: 844px){
    display:${props => (props.isOpen ? 'flex' : 'none')};
    justify-content:center;
    box-shadow: 0px 100px 95px -74px rgba(20, 156, 132, 0.5) inset, 0px 15px 25px -11px rgba(34, 60, 80, 0.2);   
    background-color: #FFFFFF;
    position: relative;
    width: 100%; 
    height: 255px; 
    border-radius:20px;
    z-index:2;
}
`
export const RelativeImageInfoWrapper = styled.div`
@media(min-width:844px){
    margin-top:25px;
    height:100%;
    display:flex;
    flex-direction:column;
    align-items:center;
    gap: 6px;
}
    @media(max-width:844px){
    margin:20px 20px 20px 20px;
    width:100%;
    height:100%;
    display:flex;
    flex-direction:column;
    gap: 10px;
}
`

export const CloseIconArrowCust = styled(CloseIconArrow)`
    margin-bottom:15px;
    margin-right:18px;
`
export const IconSideBarThreeCircle = styled(SideBarThreeCircle)`
display:flex;
position: absolute;
right:17px;
flex-direction:row;
margin:3px auto 0px auto;
height:30px !important;
width:30px !important;
cursor: pointer;
`
export const DeleteIcon = styled(SideBarDeleteIcon) <IsOwnerSideBar>`
    visibility:${props => (props.isOwner ? 'hidden' : 'visible')};
    pointer-events: ${props => (props.isOwner ? 'none' : 'auto')};
    height:40px !important;
    width:40px !important;
    cursor: pointer;
`

export const EditIcon = styled(SideBarEditIcon)`
    height:40px !important;
    width:40px !important;
    cursor: pointer;
`
export const IconDiv = styled.div<IPropsSideBar>`
    display:${props => (props.isOpen ? 'flex' : 'none')};
    justify-content: center;
    align-items: center;
    position: absolute;
    top:17px;
    width:24px;
    height: 32px; 
    background-color: #FFFFFF; 
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    box-shadow: 0px 2px 5px 1px rgba(34, 60, 80, 0.25);
    z-index: 10; 
    right:0px;
`

export const RelativeAgeText = styled(Typography)`
@media(min-width:844px){
padding: 2px 8px;
    border-radius:4px;
    background-color: #149C844D;
    color: #0E6E5D;
    font-family: Gilroy;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
}
    @media(max-width:844px){
    opacity:0.9;
    padding: 2px 8px;
    border-radius:4px;
    background-color: #149C844D;
    color: #FFFFFF;
    font-family: Gilroy;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
}

`
export const RelativeImageDiv = styled.div`
    gap:34px;
    display: flex;
    justify-content:center;
    align-items:center;
    padding-bottom:22px;
`
export const RelativeStyledImage = styled(DesktopImg)`
    height: 100px;
    display: flex;
    justify-content:center;
    width:100px;
    border-radius:8px;
    border-color:#E5E5E5;
    border-width:1px;
`
export const RelativeFioAndDateWrapper = styled.div`
    display:flex;
    flex-direction:column;
    gap:6px;
`
export const RelativeFioText = styled.div`
  @media(min-width: 844px) {
    justify-content:center;
    text-align:center;
    align-items:center;
    font-family: Gilroy,Arial,sans-serif;
    overflow: hidden; 
    text-overflow: ellipsis;
    white-space: nowrap; 
    gap:16px;
    font-weight:500;
    font-size:20px;
    line-height:130%;
    width:255px;
}
@media(max-width: 844px){
    flex-direction:row;
    font-family: Gilroy,Arial,sans-serif;
    overflow: hidden; 
    text-overflow: ellipsis;
    white-space: nowrap;
    margin:3px 0px 0px 0px;
    gap:16px;
    font-weight:500;
    font-size:20px;
    line-height:130%;
}
`
export const RelativeDateText = styled(Typography)`
@media(max-width:844px){
    width:100%;
    gap:16px;
    display: flex;
    flex-direction:row;
    color: #7F7F7F;
}
@media(min-width:844px){
    gap:16px;
    display: flex;
    flex-direction:row;
    color: #7F7F7F;
}
    

`
export const SideBarPopup = styled.div`
    display:flex;
    flex-direction:column;
    z-index:3;
    position: absolute;
    right:80px;
    width: 211px;
    justify-content:center;
    border-radius: 12px;
    background: #FFF;
    padding:4px 0px 4px 0px;
    box-shadow: 0px 12px 20px 0px rgba(32, 33, 40, 0.08), 0px 0px 1px 0px rgba(32, 33, 40, 0.12), 0px 0px 3px 0px rgba(0, 0, 0, 0.06);
`
export const PopupButton = styled.button`
padding:0px 0px 4px 12px;
border-radius: 12px;
    display:flex;
    flex-direction:row;
    border:0px #FFFFFF;
    font-family: Gilroy,Arial,sans-serif;
    background-color:#FFFFFF;
    width:100%;
    height:39px;
    font-weight:500;
    font-size:16px;
    color:#6C727F;
    line-height:130%;
    align-items:center;
    &:hover{
        background-color: #DCF0ED;
        color:#202128;
    }
`
export const Puller = styled.div`
  left:calc(50% - 21.5px);
  width: 43px;
  height: 2px;
  border-radius: 3px;
  background-color:#FFFFFF;
  position: absolute;
  top: 4px;
`
export const MiniProfileDiv = styled.div<IPropsSideBar>`
@media(min-width:844px){
    display:${props => (props.isOpen ? 'flex' : 'none')};
    flex-direction:column;
    background-color: #FFFFFF;
    width: 100%;
    height:310px; 
    overflow:auto;
}
@media(max-width:844px){
    display:${props => (props.isOpen ? 'flex' : 'none')};
    flex-direction:column;
    background-color: #FFFFFF;
    width: 100%;
    max-height:550px;
    overflow:auto;
}
`
